export default {
      id: "ic_whale-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ic_whale",
      toString: function () {
        return this.url;
      }
    }